'use strict';
//添加全局方法资源
export default {
    install: function(Vue, options) {
        //判断本地是否缓存了登陆信息，否有则判断是否token过期，过期跳登陆页，没有过期，则跳主页
        Vue.prototype.isUserLogin = function(status) {
                if (localStorage && localStorage.userInfo) {
                    var userInfo = JSON.parse(localStorage.userInfo);
                    if (!userInfo) {
                        this.$router.push('/');

                    }

                } else {
                    this.$router.push('/');
                }
            }
            //建立全局部方法，登陆成功后，保存token并设置headers
        Vue.prototype.setHttpHeaders = function(token) {

            Vue.http.headers.common['Authorization'] = "Bearer " + token;
        }

        //判断用户是否有相应的权限
        Vue.prototype.checkUsersPermission = function(num) {
            var num = num;

            var permissionArray = JSON.parse(this.dao.get('res')).Permissions || '';

            if (permissionArray.indexOf(num) > -1) {
                return true
            } else {
                return false
            }

        }

        //定义get请求方法
        Vue.prototype.getRequest = function(config) {
                var config = config;

                if (config.url != "api/Data/Captcha") { this.requestLoading(true) }

                var http = this.$http.get(config.url + '?t=' + Date.now(), { params: config.params }, { emulateJSON: true }).then(response => {

                    if (config.url != "api/Data/Captcha") { this.requestLoading(false) }
                    if (response.status == 200) {
                        return response.body;
                    }
                }, response => {
                    if (config.url != "api/Data/Captcha") { this.requestLoading(false) }

                    if (response.status == 401) {
                        localStorage.clear();
                        // this.error({ title: '提示', content: response.data.Message });
                        this.$router.push('/');
                    } else {
                        var errorMsg = response.data.Message ? response.data.Message : response.data.error_description;
                        this.error({ title: '提示', content: errorMsg || '网络出错，请重试' });
                    }

                });

                return http;
            }
            //定义patch请求方法
        Vue.prototype.patchRequest = function(config) {
            var config = config;
            this.requestLoading(true)
            var http = this.$http.patch(config.url + '?t=' + Date.now(), config.params, { emulateJSON: true }).then(response => {
                this.requestLoading(false)
                if (response.status == 200) {
                    return response.body;
                }
            }, response => {
                this.requestLoading(false)
                if (response.status == 401) {
                    localStorage.clear();
                    // this.error({ title: '提示', content: response.data.Message });
                    this.$router.push('/');
                } else {
                    var errorMsg = response.data.Message ? response.data.Message : response.data.error_description;
                    this.error({ title: '提示', content: errorMsg || '网络出错，请重试' });
                }
            });

            return http;
        }

        //定义post请求方法
        Vue.prototype.postRequest = function(config) {

            this.requestLoading(true)

            var http = this.$http.post(config.url + '?t=' + Date.now(), config.params, { emulateJSON: true }).then(response => {
                this.requestLoading(false)
                if (response.status == 200) {
                    return response.body;
                }
            }, response => {
                this.requestLoading(false)

                if (config.url.indexOf("api/Token") > -1 && response.status == 400) {

                    return response.body;
                }
                if (response.status == 401) {
                    localStorage.clear();
                    // this.error({ title: '提示', content: response.data.Message });
                    this.$router.push('/');
                } else {
                    var errorMsg = response.data.Message ? response.data.Message : response.data.error_description;
                    this.error({ title: '提示', content: errorMsg || '网络出错，请重试' });
                }
            });
            return http;
        }

        // 请求时显示一个加载数据的图标
        Vue.prototype.requestLoading = function(status) {
            var html = "<div class='loading-mask'>\
                            <div class='loading-img'></div>\
                        </div>";
            var app = document.getElementById('app');
            var body = document.getElementsByTagName('body')[0];
            var temp = document.createElement('div');
            temp.id = 'loadingBox';
            var isLoadingExist = document.getElementsByClassName('loading-img').length > 0 ? true : false;
            if (isLoadingExist && status) return;
            if (status) {
                // body.style.overflow='hidden';
                temp.innerHTML = html;
                app.appendChild(temp);
            } else {
                var target = document.getElementById('loadingBox');
                if (target) {
                    app.removeChild(target);
                }
                // body.style.overflow='auto';

            }

        }


        //页面跳转
        Vue.prototype.routetoPage = function(url) {

            this.$router.push(url);

        }

        // 表格模式切换保存本地
        Vue.prototype.tableModule = function(name) {
            this.dao.set('tableModule', name);
        }

        //只能输入数字，且只能输入2位数
        Vue.prototype.numberOnly = function(obj) {

                obj = obj.replace(/[^\d.]/g, ""); //清除“数字”和“.”以外的字符   
                obj = obj.replace(/\.{2,}/g, "."); //只保留第一个. 清除多余的   
                obj = obj.replace(".", "$#$").replace(/\./g, "").replace("$#$", ".");
                obj = obj.replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3'); //只能输入两个小数   
                if (obj.indexOf(".") < 0 && obj != "") { //以上已经过滤，此处控制的是如果没有小数点，首位不能为类似于 01、02的金额  
                    obj = parseFloat(obj);
                }


            }
            //计算时间差
        Vue.prototype.getDaysSize = function(s1, s2) {
                var s1 = new Date(s1);
                var s2 = new Date(s2);

                var days = s2.getTime() - s1.getTime();
                var time = Math.round(days / (1000 * 60 * 60 * 24));
                return time;
            }
            //日期期格式化周几  
        Vue.prototype.getWeekday = function(date) {
            date = date.replace(/-/g, "/")
            var mydate = new Date(date);
            var myday = mydate.getDay() //注:0-6对应为星期日到星期六 

            return myday;
        }

        //  //日期期格式化周几  
        // Vue.prototype.getWeekday=function (date) {
        //     var nowDate=new Date();
        //     var days=this.getDaysSize(nowDate,date);
        //     var mydate=new Date(date); 
        //     var myday=mydate.getDay()//注:0-6对应为星期日到星期六 
        //     return myday;
        // }



        //获取日期,count=1为明天，count=-1为前一天
        Vue.prototype.getDate = function(count) {
                var date = new Date();
                date.setDate(date.getDate() + count); //获取count天后的日期 
                var year = date.getFullYear();
                var month = date.getMonth() + 1;
                var day = date.getDate();
                if (month >= 1 && month <= 9) {
                    month = "0" + month;
                }
                if (day >= 0 && day <= 9) {
                    day = "0" + day;
                }

                var time = year + '-' + month + '-' + day;
                return time;
            }
            //获取下一天日期
        Vue.prototype.getNextDay = function(date, num) {
                var date = new Date(date);
                date.setDate(date.getDate() + (num || 1));
                //获取count天后的日期 
                var year = date.getUTCFullYear();
                var month = date.getUTCMonth() + 1;
                var day = date.getUTCDate();
                if (month >= 1 && month <= 9) {
                    month = "0" + month;
                }
                if (day >= 0 && day <= 9) {
                    day = "0" + day;
                }

                var time = year + '-' + month + '-' + day;
                return time;
            }
            //获取上一天日期
        Vue.prototype.getLastDay = function(date, num) {
            var date = new Date(date);
            date.setDate(date.getDate() - (num || 1));
            //获取count天后的日期 
            var year = date.getUTCFullYear();
            var month = date.getUTCMonth() + 1;
            var day = date.getUTCDate();
            if (month >= 1 && month <= 9) {
                month = "0" + month;
            }
            if (day >= 0 && day <= 9) {
                day = "0" + day;
            }

            var time = year + '-' + month + '-' + day;
            return time;
        }

        //日期期格式化为 0000/00/00
        Vue.prototype.dateToDvdFormat = function(date) {
            if (!date) return '';

            var da = new Date(date);
            var year = da.getFullYear() + '/';
            var month = da.getMonth() + 1;
            var day = da.getDate();
            if (day < 10) { day = '0' + day };
            if (month < 10) { month = '0' + month };
            return year + month + '/' + day;
        };
        //获取日份,count=1为下一个月，count=-1为上一个月
        Vue.prototype.getNormalMonth = function(count) {


            var date = new Date();
            date.setMonth(date.getMonth() + count, 1);

            var year = date.getFullYear();
            var month = date.getMonth() + 1;

            if (month < 10) { month = '0' + month };
            var time = String(year) + '-' + String(month);


            return time;
        }

        Vue.prototype.getFormatMonth = function(date) {
                if (!date) return '';

                var da = new Date(date);
                var year = da.getFullYear();

                var month = da.getMonth() + 1;

                if (month < 10) { month = '0' + month };
                return String(year) + String(month);
            }
            //格式化月份为2017-06
        Vue.prototype.getFormatMonthLine = function(date) {
                if (!date) return '';

                var da = new Date(date);
                var year = da.getFullYear();

                var month = da.getMonth() + 1;

                if (month < 10) { month = '0' + month };
                return String(year) + '-' + String(month);
            }
            //格式化月份为20170601
        Vue.prototype.getFormatDay = function(date) {
            if (!date) return '';

            var da = new Date(date);
            var year = da.getFullYear();

            var month = da.getMonth() + 1;
            var day = da.getDate();
            if (day < 10) { day = '0' + day };
            if (month < 10) { month = '0' + month };
            return String(year) + String(month) + String(day);
        }

        //格式化月份为2017-06-01
        Vue.prototype.getFormatDayLine = function(date) {
                if (!date) return '';

                var da = new Date(date);
                var year = da.getFullYear();

                var month = da.getMonth() + 1;
                var day = da.getDate();
                if (day < 10) { day = '0' + day };
                if (month < 10) { month = '0' + month };
                return String(year) + '-' + String(month) + '-' + String(day);
            }
            //获取日期,count=1为明天，count=-1为前一天
        Vue.prototype.getMonth = function() {

            var da = new Date();
            var year = da.getFullYear() + '-';

            var month = da.getMonth() + 1;

            if (month < 10) { month = '0' + month };
            return year + month;
        }
        Vue.prototype.setBodyScroll = function(val) {
            var body = document.getElementsByTagName('body')[0];
            if (val) {
                body.style.overflow = 'hidden';
                body.style.position = 'fixed';
            } else {
                body.style.overflow = 'auto';
                body.style.position = 'relative';
            }

        }

        Vue.prototype.maxNum = function(array, name) {
                var array = array;
                if (!array || array.length < 1) return;
                var max = 0;
                array.forEach(function(index, value, array) {
                    if (max < index[name].length)
                        max = index[name].length
                })
                return max;

            }
            //判断是否用户超出三个

        Vue.prototype.isUserNameOverflow = function(nameList) {
            var list = nameList.split(',');
            var name = [];
            if (list.length > 3) {
                name = name.concat(list[0], list[1], list[2]);
                return name.join(',');

            } else {
                return false;
            }

        }
        Vue.prototype.error = function(val) {

            var isCloseError = document.getElementById('closeError') ? true : false;

            if (isCloseError) return;

            var html = "<div class='mask'>\
                        <div class='error-box'>\
                        <h1>" + val.title + "</h1>\
                        <h2>" + val.content + "</h2>\
                        <div id='closeError' >OK</div>\
                        </div>\
                        </div>"
            var app = document.getElementById('app');

            var body = document.getElementsByTagName('body')[0];
            var temp = document.createElement('div');
            temp.id = 'errorBox';

            body.style.overflow = 'hidden';
            temp.innerHTML = html;
            app.appendChild(temp);

            var closeError = document.getElementById('closeError');
            closeError.onclick = function() {

                var target = document.getElementById('errorBox');
                body.style.overflow = 'auto';
                app.removeChild(target)
            }

        }
        Vue.prototype.loadingData = function(status, val) {

            if (status) {
                var html = "<div class='error-box'>\
                            <h1>" + val.title + "</h1>\
                            <h2>" + val.content + "</h2>\
                         </div>"
                var app = document.getElementById('app');

                var body = document.getElementsByTagName('body')[0];
                var temp = document.createElement('div');
                temp.id = 'loadingDataBox';

                body.style.overflow = 'hidden';
                temp.innerHTML = html;
                app.appendChild(temp);
            } else {
                var app = document.getElementById('app');
                var body = document.getElementsByTagName('body')[0];
                var target = document.getElementById('loadingDataBox');
                body.style.overflow = 'auto';
                if (!target) {
                    return;

                }
                app.removeChild(target)
            }

        }
        Vue.prototype.comfirmBox = function(val) {
            var isCloseError = document.getElementById('comfirmBox') ? true : false;

            if (isCloseError) return;

            var html = "<div class='error-box'>\
                        <h1>" + val.title + "</h1>\
                        <h2>" + val.content + "</h2>\
                     </div>"
            var app = document.getElementById('app');

            var body = document.getElementsByTagName('body')[0];
            var temp = document.createElement('div');
            temp.id = 'errorBox';

            body.style.overflow = 'hidden';
            temp.innerHTML = html;
            app.appendChild(temp);

        }
    }
};


// WEBPACK FOOTER //
// ./src/common/functions.js